import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const cortexXsoar = defineConnector({
  identifier: "cortexXsoar",
  name: "Cortex XSOAR",
  tagLine: "Security orchestration, automation, and response",
  logo,
  protocol: "http",
  tags: ["featured", "security"],
  defaultUrlPattern: ({ host }) => domainToRegex(host),
  auth: (app) =>
    headerAuth([{ name: "Authorization", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "Log into your Cortex XSOAR instance. Navigate to **Settings** > **Integrations** > **API Keys** and generate a new key.",
        },
      ],
    },
    {
      title: "Enter your details",
      items: [
        {
          kind: "baseUrl",
          label: "XSOAR URL",
          placeholder: "https://xsoar.example.com",
          required: true,
          target: { kind: "configuration", field: "host" },
          helperText:
            "The URL of your Cortex XSOAR instance, including any path it’s served under.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
          helperText: "Your Cortex XSOAR API key.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ host }) => `${host}/user`,
  },
});
